import capitalize from 'underscore.string/capitalize';

angular.module('gym.pos').factory('ReconciliationsService', ["ContrastColor", function(ContrastColor) {
  return {
    parse: function(data) {
      return _.map(data, function(day) {
        day.title = capitalize(day.status);
        day.start = day.sale_date;
        day.end = day.sale_date;
        day.color = (function() {
          switch (day.status) {
            case 'reconciled':
              return '#43b837';
            case 'mismatch':
              return '#ed0000';
            case 'pending':
              return '#9e9e9e';
          }
        })();
        day.textColor = ContrastColor.get(day.color, {
          darkColor: '#303030'
        });
        return day;
      });
    }
  };
}]);
